exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-item[data-v-b30d590a]{margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:20px;width:220px;font-size:14px;color:#5b6981;font-weight:600;line-height:20px}.filter-item .text-wrapper[data-v-b30d590a]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.filter-badge[data-v-b30d590a]{display:inline-block;background:#eaedf3;color:#778295;min-width:16px;height:16px;padding:0 4px;border-radius:12px;font-size:12px;line-height:16px}", ""]);

// exports
